"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var errors = _interopRequireWildcard(require("./errors-const"));

var _typesConst = require("../const/types-const");

var _captionViewService = _interopRequireDefault(require("./caption-view-service"));

var _clipsViewService = _interopRequireDefault(require("./clips-view-service"));

var _musicViewService = _interopRequireDefault(require("./music-view-service"));

var _utils = require("../utils");

var videoEvents = _interopRequireWildcard(require("../const/video-events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

let map; // tween max timeline

let timeline;
let videoScale = 1;

class ViewService {
  constructor(config) {
    _defineProperty(this, "time", time => {
      if (timeline) {
        if (time === undefined || time === null) {
          return timeline.time() || 0;
        }

        const _time = Math.min(Math.max(time, 0), this.duration); // update music track on time


        this.musicViewService.onSeek(_time); // need to check if it ok to remove it or not
        // if (!this.paused) {
        //     return this.pause(time);
        // }\

        timeline.time(_time);
        this.dispatchEvent(videoEvents.SEEKED);
        return timeline.time();
      }

      return 0;
    });

    _defineProperty(this, "play", (time, muted) => {
      if (timeline) {
        timeline.play(time, false);
        this.captionViewService.onPlay();
        this.musicViewService.onPlay(this.time(), muted);
        this.dispatchEvent(videoEvents.PLAY);
        this.dispatchPlayEvent(muted === undefined ? false : muted);
      }
    });

    _defineProperty(this, "pause", time => {
      if (timeline) {
        timeline.pause(time, false);
        this.clipsViewService.onPaused();
        this.musicViewService.onPaused();

        if (this.progress !== 1) {
          // dispatch pause event only if not ended
          this.dispatchEvent(videoEvents.PAUSE);
          this.dispatchPauseEvent();
        }

        return timeline.time();
      }

      return 0;
    });

    if (config) {
      this.logger = config.logger || function () {};
    }

    const selectors = config.selectors || '#container';
    const domEl = config.domEl || null; // set ref to container dom element

    const wrapper = domEl || document.querySelector(selectors);
    this.eventTarget = wrapper;
    this.video = wrapper; // set new map

    map = new Map(); // set time line

    timeline = new _gsap.TimelineMax({
      paused: true,
      repeat: 0,
      align: 'normal',
      onUpdateParams: ['{self}'],
      onUpdate: self => {
        this.dispatchEvent(videoEvents.TIMEUPDATE);

        if (this.onUpdate) {
          this.onUpdate.call(null, self.time(), self.paused());
        }
      },
      onComplete: () => {
        this.logger.log('timeline - complate');
        this.dispatchEvent(videoEvents.ENDED);
        this.pause();

        if (this.onComplete) {
          this.onComplete.call(null);
        }
      }
    });
    const extendConfig = { ...config,
      wrapper,
      timeline,
      map,
      play: this.play,
      pause: this.pause,
      time: this.time
    };
    this.clipsViewService = new _clipsViewService.default(extendConfig);
    this.captionViewService = new _captionViewService.default(extendConfig);
    this.musicViewService = new _musicViewService.default(extendConfig);
  }

  set scale(scale) {
    this.captionViewService.scale = scale;
    this.clipsViewService.scale = scale;
    videoScale = scale;
  }

  get scale() {
    return videoScale;
  }

  get progress() {
    return (0, _utils.fixedNum)(timeline.progress(), 2);
  }

  get duration() {
    return timeline.duration() || 0;
  }

  get paused() {
    return timeline.paused();
  }

  set volume(value) {
    this.musicViewService.volume = Math.max(0, Math.min(value, 1));
    this.dispatchEvent(videoEvents.VOLUMECHANGE);
  }

  get volume() {
    return this.musicViewService.volume;
  }

  set muted(value) {
    this.musicViewService.muted = !!value;
    this.dispatchEvent(videoEvents.VOLUMECHANGE);
  }

  get muted() {
    return this.musicViewService.muted;
  }

  clear() {
    map.forEach((value, key) => {
      this.destroy(key);
    });
    this.captionViewService.clear();
    this.clipsViewService.clear();

    if (this.timeline && timeline.clear) {
      timeline.clear();
    }
  }

  async create(data, ratio, type, imageQuality) {
    this.dispatchEvent(videoEvents.LOADSTART);

    switch (type) {
      case _typesConst.CAPTION:
        await this.captionViewService.create(data, ratio);
        break;

      case _typesConst.CLIP:
        await this.clipsViewService.create(data, ratio, imageQuality);
        break;

      case _typesConst.MUSIC:
        await this.musicViewService.create(data);
        break;

      default:
        await Promise.all([this.captionViewService.create(data, ratio), this.clipsViewService.create(data, ratio, imageQuality), this.musicViewService.create(data)]);
        break;
    }

    this.dispatchEvent(videoEvents.CANPLAY);
  }

  async render(guid, data, type, imageQuality) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (type === _typesConst.WATERMARK) {
      await this.captionViewService.render(guid, data.watermark, type);
    }

    if (type === _typesConst.CAPTION) {
      await this.captionViewService.render(guid, data.captions, type);
    }

    if (type === _typesConst.MUSIC) {
      // for now get the first track from music
      const {
        music,
        duration
      } = data;
      const track = music[0];
      await this.musicViewService.render(track, duration);
    }

    if (type === _typesConst.CLIP) {
      await this.clipsViewService.render(guid, data.clips, imageQuality);
    }
  }

  destroy(guid) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    if (map.has(guid)) {
      const {
        destroyFunc
      } = map.get(guid);
      destroyFunc.call();
      map.delete(guid);
    }
  }

  goToIdle(guid, direct) {
    return this.captionViewService.goToIdle(guid, direct);
  }

  updateCaptionSizeAndPosition(guid, rect) {
    return this.captionViewService.updateCaptionSizeAndPosition(guid, rect);
  }

  updateCaptionInputs(guid, inputs) {
    return this.captionViewService.updateCaptionInputs(guid, inputs);
  }

  updateCaptionColors(guid, colors) {
    return this.captionViewService.updateCaptionColors(guid, colors);
  }

  updateLogoSizeAndPosition(guid, rect) {
    return this.captionViewService.updateLogoSizeAndPosition(guid, rect);
  }

  updateLogoImageScale(guid, scale) {
    return this.captionViewService.updateLogoImageScale(guid, scale);
  }

  dispatchEvent(type) {
    this.eventTarget.dispatchEvent(new Event(type));
  }

  dispatchPlayEvent(muted) {
    if (_.isFunction(this.onPlayEvent)) {
      this.onPlayEvent(muted);
    }
  }

  dispatchPauseEvent() {
    if (_.isFunction(this.onPauseEvent)) {
      this.onPauseEvent();
    }
  }

}

exports.default = ViewService;